exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner {\n}\n\n.double-bounce1, .double-bounce2 {\n    width:  60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: #363;\n    opacity: 0.6;\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    z-index: 2;\n    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;\n    animation: sk-bounce 2.0s infinite ease-in-out;\n}\n\n.double-bounce2 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n}\n\n@-webkit-keyframes sk-bounce {\n    0%, 100% {\n        -webkit-transform: scale(0.0)\n    }\n    50% {\n        -webkit-transform: scale(1.0)\n    }\n}\n\n@keyframes sk-bounce {\n    0%, 100% {\n        transform: scale(0.0);\n        -webkit-transform: scale(0.0);\n    }\n    50% {\n        transform: scale(1.0);\n        -webkit-transform: scale(1.0);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_directives/spinner/spinner.component.css
// module id = ../../../../../src/app/_directives/spinner/spinner.component.css
// module chunks = main